<template>
  <div>
    <div>{{produto.labelProduto}}</div>
    <div>{{produto.componentes}}</div>
  </div>
</template>

<script>
import ProdutoDropdownItem from './produto-dropdown-item.js'
export default ProdutoDropdownItem
</script>

<style scoped>

</style>
